import React, { useEffect, useState } from 'react'
import '../../components/kyc/kycStyle.css'
import ScreenLayout from '../../components/layouts/ScreenLayout'
import {
  API_ERROR_MESSAGE,
  BANK_VERIFICATION_ACCOUNT_TYPE_OPTIONS,
  BANK_VERIFICATION_BRANCH_CODE_OPTIONS,
  BANK_VERIFICATION_REASON,
  BANK_VERIFICATION_SEARCH_OPTIONS,
  INVALID_ID_WARNING,
  PRICELIST,
  SANCTION_SCREENING_OPTIONS,
} from '../../utils/Constants'
import { Form, Spinner } from 'react-bootstrap'
import SearchBySelect from '../../components/form/SearchBySelect/SearchBySelect'
import { requestBankVerificationSearch } from '../../api/bankVerification'
import FormInput from '../../components/form/FormInput/FormInput'
import { validateIdNumber } from '../../utils/Validation'
import Alert from '../../components/form/Alerts/BasicAlert'
import FooterButtons from '../../components/form/FooterButtons/FooterButtons'
import KycButton from '../../components/form/Button/Button'
import Disclaimer from '../../components/BridgingFinance/Disclaimer'
import { useDownloadFile } from '../../hooks/use-download-file'
import { ReportTypes } from '../../api/apiConstants'

type bankVerificationScreeningCompany = {
  verificationType: number
  entity: number
  firstname: string
  initials?: string
  surname: string
  iDorPassportNo: string
  idType: number
  companyName: string
  trustNo: string
  accountNo: string
  branchCode: string
  accountType: string
  bankName: string
  voucherCode: string
  yourReference: string
  reportType: number
  verificationReason: string
}

interface BankVerificationProps {
  setShow: (value: boolean) => void
  setIsError: (value: boolean) => void
  setErrorMessage: (value: string) => void
  initialState: { [key: string]: any }
  setInitialState: React.Dispatch<React.SetStateAction<any>>
  KYCAccess: boolean
}
export const BankAccountVerification: React.FC<BankVerificationProps> = ({
  setIsError,
  setErrorMessage,
  setShow,
  setInitialState,
  initialState,
  KYCAccess,
}) => {
  const [missingFields, setMissingFields] = useState<string[]>([])
  const [showProgress, setShowProgress] = useState(false)
  const [isDisabled, setIsDisabled] = useState(true)
  const [bankVerifications, setBankVerifications] = useState<
    bankVerificationScreeningCompany[]
  >([])
  const [bankVerification, setBankVerification] =
    useState<bankVerificationScreeningCompany>({
      accountNo: '',
      accountType: '',
      bankName: '',
      branchCode: '',
      companyName: '',
      entity: 0,
      firstname: '',
      iDorPassportNo: '',
      idType: 0,
      initials: '',
      reportType: 0,
      surname: '',
      trustNo: '',
      verificationReason: '',
      verificationType: 0,
      voucherCode: '',
      yourReference: '',
    })
  const [reportId, setReportId] = useState('0')

  const [searchBySelectedOption, setSearchBySelectedOption] = useState('')
  const [iDorPassportNo, setiDorPassportNo] = useState('')
  const [surname, setSurname] = useState('')
  const [accountNo, setAccountNo] = useState('')
  const [selectedBranchCode, setSelectedBranchCode] = useState('')
  const [selectedAccountType, setSelectedAccountType] = useState('')
  const [selectedVerificationReason, setSelectedVerificationReason] =
    useState('')
  const [yourReference, setYourReference] = useState('')
  const [titleType, setTitleType] = useState<'FULL' | 'SECTIONAL'>('FULL')
  const [companyorTrustName, setCompanyorTrustName] = useState('')
  const [verificationType, setVerificationType] = useState(0)
  const [entity, setEntity] = useState(0)
  const [initials, setInitials] = useState('')
  const [firstname, setFirstname] = useState('')
  const [idType, setIdType] = useState(0)
  const [trustNo, setTrustNo] = useState('')
  const [bankName, setBankName] = useState('')
  const [voucherCode, setVoucherCode] = useState('')
  const [reportType, setReportType] = useState(16)
  const [formValues, setFormValues] = useState<
    {
      searchBySelectedOption: string
      verificationType: number
      entity: number
      firstname: string
      initials: string
      surname: string
      iDorPassportNo: string
      idType: number
      companyorTrustName: string
      trustNo: string
      accountNo: string
      branchCode: string
      accountType: string
      bankName: string
      voucherCode: string
      yourReference: string
      reportType: number
      verificationReason: string
    }[]
  >([])

  useEffect(() => {
    setSearchBySelectedOption('INDIVIDUAL')
  }, [])

  useEffect(() => {
    resetInputValues()
  }, [
    searchBySelectedOption,
    setSelectedBranchCode,
    setSelectedAccountType,
    setSelectedVerificationReason,
  ])

  useEffect(() => {
    setFormValues([
      {
        searchBySelectedOption: searchBySelectedOption,
        verificationType: verificationType,
        entity: entity,
        initials: initials,
        firstname: firstname,
        surname: surname,
        iDorPassportNo: iDorPassportNo,
        idType: idType,
        companyorTrustName: companyorTrustName,
        trustNo: trustNo,
        accountNo: accountNo,
        branchCode: selectedBranchCode,
        accountType: selectedAccountType,
        bankName: bankName,
        voucherCode: voucherCode,
        yourReference: yourReference,
        reportType: reportType,
        verificationReason: selectedVerificationReason,
      },
    ])
  }, [
    searchBySelectedOption,
    verificationType,
    entity,
    initials,
    firstname,
    surname,
    iDorPassportNo,
    idType,
    companyorTrustName,
    trustNo,
    accountNo,
    selectedBranchCode,
    selectedAccountType,
    bankName,
    voucherCode,
    yourReference,
    reportType,
    selectedVerificationReason,
  ])

  const resetInputValues = () => {
    setiDorPassportNo('')
    setSurname('')
    setAccountNo('')
    setSelectedBranchCode('')
    setSelectedAccountType('')
    setSelectedVerificationReason('')
    // Reset values for other dropdowns here...
  }

  const updateInitialState = () => {
    setInitialState({
      ...initialState,
      sanctionScreening: {
        verificationType: verificationType,
        entity: entity,
        initials: initials,
        firstname: firstname,
        surname: surname,
        iDorPassportNo: iDorPassportNo,
        idType: idType,
        companyorTrustName: companyorTrustName,
        trustNo: trustNo,
        accountNo: accountNo,
        branchCode: selectedBranchCode,
        accountType: selectedAccountType,
        bankName: bankName,
        voucherCode: voucherCode,
        yourReference: yourReference,
        reportType: reportType,
        verificationReason: selectedVerificationReason,
      },
    })
  }

  const { mutate: downloadReport, isLoading: isDownloading } = useDownloadFile(
    '/BankAccountVerification/download-report',
    reportId,
    ReportTypes.BankVerificationSearch.reportTypeId,
    setIsError,
    setErrorMessage,
  )
  const handleBankVerificationSearch = async () => {
    updateInitialState()
    const missing = []

    if (searchBySelectedOption === 'INDIVIDUAL') {
      if (iDorPassportNo === '' || iDorPassportNo?.trim() === '') {
        if (!iDorPassportNo) missing.push('ID number')
        validateIdNumber(iDorPassportNo!)
      }
      if (initials === '' || initials?.trim() === '') {
        if (!initials) missing.push('Initials')
      } else if (initials.length < 1 || initials.length > 3) {
        missing.push('Initials must have between 1 and 3 characters.')
      }
      if (firstname === '' || firstname?.trim() === '') {
        if (!firstname) missing.push('First name')
      }
      if (surname === '' || surname?.trim() === '') {
        if (!surname) missing.push('Surname')
      }
      if (accountNo === '' || accountNo?.trim() === '') {
        if (!accountNo) missing.push('Account number')
      }
      if (selectedBranchCode === '') {
        if (!selectedBranchCode) missing.push('Branch Code')
      }
      if (selectedAccountType === '') {
        if (!selectedAccountType) missing.push('Account Type')
      }
      if (
        selectedVerificationReason === '' ||
        selectedVerificationReason?.trim() === ''
      ) {
        if (!selectedVerificationReason) missing.push('Verification Reason')
      }
    }

    if (searchBySelectedOption === 'COMPANY') {
      if (iDorPassportNo === '' || iDorPassportNo?.trim() === '') {
        if (!iDorPassportNo) missing.push('Registration Number')
        validateIdNumber(iDorPassportNo!)
      }
      if (companyorTrustName === '' || companyorTrustName?.trim() === '') {
        if (!companyorTrustName) missing.push('Company Name')
      }
      if (selectedBranchCode === '') {
        if (!selectedBranchCode) missing.push('Branch Code')
      }
      if (accountNo === '' || accountNo?.trim() === '') {
        if (!accountNo) missing.push('Account number')
      }
      if (selectedAccountType === '') {
        if (!selectedAccountType) missing.push('Account Type')
      }
      if (
        selectedVerificationReason === '' ||
        selectedVerificationReason?.trim() === ''
      ) {
        if (!selectedVerificationReason) missing.push('Verification Reason')
      }
    }

    if (searchBySelectedOption === 'TRUST') {
      if (iDorPassportNo === '' || iDorPassportNo?.trim() === '') {
        if (!iDorPassportNo) missing.push('Trust Number')
        validateIdNumber(iDorPassportNo!)
      }
      if (companyorTrustName === '' || companyorTrustName?.trim() === '') {
        if (!companyorTrustName) missing.push('Trust Name')
      }
      if (selectedBranchCode === '') {
        if (!selectedBranchCode) missing.push('Branch Code')
      }
      if (accountNo === '' || accountNo?.trim() === '') {
        if (!accountNo) missing.push('Account number')
      }
      if (selectedAccountType === '') {
        if (!selectedAccountType) missing.push('Account Type')
      }
      if (
        selectedVerificationReason === '' ||
        selectedVerificationReason?.trim() === ''
      ) {
        if (!selectedVerificationReason) missing.push('Verification Reason')
      }
    }

    setMissingFields(missing)
    if (missing.length > 0) {
      return alert(`Please fill in the following fields: ${missing.join(', ')}`)
    }

    switch (searchBySelectedOption) {
      case 'COMPANY':
        requestBankVerificationSearch({
          downloadReport,
          setReportId,
          verificationType: 1,
          entity: 1,
          initials: initials,
          firstname: firstname,
          surname: surname,
          iDorPassportNo: iDorPassportNo,
          idType: 1,
          companyorTrustName: companyorTrustName,
          trustNo: trustNo,
          accountNo: accountNo,
          branchCode: selectedBranchCode,
          accountType: selectedAccountType,
          bankName: bankName,
          voucherCode: voucherCode,
          yourReference: yourReference,
          reportType: reportType,
          verificationReason: selectedVerificationReason,
          setShowProgress,
          setIsError,
          setErrorMessage,
        })
        break
      case 'TRUST':
        requestBankVerificationSearch({
          downloadReport,
          setReportId,
          verificationType: 2,
          entity: 2,
          initials: initials,
          firstname: firstname,
          surname: surname,
          iDorPassportNo: iDorPassportNo,
          idType: 2,
          companyorTrustName: companyorTrustName,
          trustNo: trustNo,
          accountNo: accountNo,
          branchCode: selectedBranchCode,
          accountType: selectedAccountType,
          bankName: bankName,
          voucherCode: voucherCode,
          yourReference: yourReference,
          reportType: reportType,
          verificationReason: selectedVerificationReason,
          setShowProgress,
          setIsError,
          setErrorMessage,
        })
        break
      case 'INDIVIDUAL':
        requestBankVerificationSearch({
          downloadReport,
          setReportId,
          verificationType: 0,
          entity: 0,
          initials: initials,
          firstname: firstname,
          surname: surname,
          iDorPassportNo: iDorPassportNo,
          idType: 0,
          companyorTrustName: companyorTrustName,
          trustNo: trustNo,
          accountNo: accountNo,
          branchCode: selectedBranchCode,
          accountType: selectedAccountType,
          bankName: bankName,
          voucherCode: voucherCode,
          yourReference: yourReference,
          reportType: reportType,
          verificationReason: selectedVerificationReason,
          setShowProgress,
          setIsError,
          setErrorMessage,
        })
        break
      default:
        break
    }
  }

  const loadConsumerReport = async () => {
    const handleBankVerificationParams = {
      verificationType: 2,
      entity: 2,
      initials: initials,
      firstname: firstname,
      surname: surname,
      iDorPassportNo: iDorPassportNo,
      idType: idType,
      companyorTrustName: companyorTrustName,
      trustNo: trustNo,
      accountNo: accountNo,
      branchCode: selectedBranchCode,
      accountType: selectedAccountType,
      bankName: bankName,
      voucherCode: voucherCode,
      yourReference: yourReference,
      reportType: reportType,
      verificationReason: selectedVerificationReason,
      setShowProgress,
      setIsError,
      setErrorMessage,
      setReportId,
      downloadReport,
    }
    // @ts-ignore
    requestBankVerificationSearch(handleBankVerificationParams)
  }

  const handleStartOver = () => {
    setSearchBySelectedOption('INDIVIDUAL')
    setReportId('0')
    setShowProgress(false)
    setIsDisabled(false)
    setBankVerifications([])
    setSearchBySelectedOption('')
    setiDorPassportNo('')
    setSurname('')
    setAccountNo('')
    setSelectedBranchCode('')
    setSelectedAccountType('')
    setSelectedVerificationReason('')
    setYourReference('')
    setTitleType('FULL')
    setCompanyorTrustName('')
    setVerificationType(0)
    setEntity(0)
    setInitials('')
    setFirstname('')
    setIdType(0)
    setTrustNo('')
    setBankName('')
    setVoucherCode('')
    setReportType(16)
  }

  return (
    <ScreenLayout
      headerText={'Bank Account Verification'}
      subHeaderText={
        'Realtime Bank Account Verification for ABSA, African Bank, Capitec, FNB, Investec, Nedbank, Standard Bank, Discovery Bank and Sasfin Bank active account holders.'
      }
      price={PRICELIST.BANK_ACCOUNT_VERIFICATION}
    >
      <>
        {Object.keys(bankVerifications).length === 0 && (
          <>
            {showProgress && (
              <>
                <div className="spinner-container">
                  <Spinner
                    as="span"
                    animation="border"
                    variant="dark"
                    role="status"
                    aria-hidden="true"
                  ></Spinner>
                  <span> </span>
                </div>
              </>
            )}

            {!KYCAccess && (
              <p className="lbl-red">
                You do not have access to this report, please consult with your
                administrator to give you access.
              </p>
            )}

            <SearchBySelect
              className="mb-2"
              onChangeHandler={setSearchBySelectedOption}
              options={BANK_VERIFICATION_SEARCH_OPTIONS.searchBy}
            />

            {searchBySelectedOption === 'INDIVIDUAL' && (
              <>
                <FormInput
                  onChangeHandler={setiDorPassportNo}
                  placeHolderText="ID number"
                  required
                  value={iDorPassportNo}
                  className="mb-2 custom-input"
                />
                {iDorPassportNo && !validateIdNumber(iDorPassportNo) && (
                  <Alert variant="danger" text={INVALID_ID_WARNING} />
                )}
                <FormInput
                  onChangeHandler={setInitials}
                  placeHolderText="Initials"
                  required
                  value={initials}
                  className="mb-2 custom-input"
                />
                <FormInput
                  onChangeHandler={setFirstname}
                  placeHolderText="Firstname"
                  required
                  value={firstname}
                  className="mb-2 custom-input"
                />
                <FormInput
                  onChangeHandler={setSurname}
                  placeHolderText="Surname"
                  required
                  value={surname}
                  className="mb-2 custom-input"
                />
                <FormInput
                  onChangeHandler={setAccountNo}
                  placeHolderText="Account number"
                  required
                  value={accountNo}
                  className="mb-2 custom-input"
                />
                <Form.Select
                  value={selectedBranchCode}
                  onChange={(e) => setSelectedBranchCode(e.target.value)}
                  className="mb-2 custom-input"
                  style={{ maxWidth: '430px' }}
                >
                  <option disabled value="">
                    Select Branch Code
                  </option>
                  {BANK_VERIFICATION_BRANCH_CODE_OPTIONS.searchBy.map(
                    (branch) => (
                      <option key={branch.id} value={branch.id}>
                        {branch.name}
                      </option>
                    ),
                  )}
                </Form.Select>
                <Form.Select
                  value={selectedAccountType}
                  onChange={(e) => setSelectedAccountType(e.target.value)}
                  className="mb-2 custom-input"
                  style={{ maxWidth: '430px' }}
                >
                  <option disabled value="">
                    Select Account Type
                  </option>
                  {BANK_VERIFICATION_ACCOUNT_TYPE_OPTIONS.searchBy.map(
                    (branch) => (
                      <option key={branch.id} value={branch.id}>
                        {branch.name}
                      </option>
                    ),
                  )}
                </Form.Select>
                <Form.Select
                  value={selectedVerificationReason}
                  onChange={(e) =>
                    setSelectedVerificationReason(e.target.value)
                  }
                  className="mb-2 custom-input"
                  style={{ maxWidth: '430px' }}
                >
                  <option disabled value="">
                    Select Verification Reason
                  </option>
                  {BANK_VERIFICATION_REASON.searchBy.map((branch) => (
                    <option key={branch.id} value={branch.id}>
                      {branch.name}
                    </option>
                  ))}
                </Form.Select>
                <FormInput
                  onChangeHandler={setYourReference}
                  placeHolderText="Search reference"
                  value={yourReference}
                  className="mb-2 custom-input"
                />
              </>
            )}

            {searchBySelectedOption === 'COMPANY' && (
              <>
                <FormInput
                  onChangeHandler={setiDorPassportNo}
                  placeHolderText="Registration number"
                  value={iDorPassportNo}
                  className="mb-2 custom-input"
                />
                <FormInput
                  onChangeHandler={setCompanyorTrustName}
                  placeHolderText="Company Name"
                  required
                  value={companyorTrustName}
                  className="mb-2 custom-input"
                />
                <Form.Select
                  value={selectedBranchCode}
                  onChange={(e) => setSelectedBranchCode(e.target.value)}
                  className="mb-2 custom-input"
                  style={{ maxWidth: '430px' }}
                >
                  <option disabled value="">
                    Select Branch Code
                  </option>
                  {BANK_VERIFICATION_BRANCH_CODE_OPTIONS.searchBy.map(
                    (branch) => (
                      <option key={branch.id} value={branch.id}>
                        {branch.name}
                      </option>
                    ),
                  )}
                </Form.Select>
                <FormInput
                  onChangeHandler={setAccountNo}
                  placeHolderText="Account number"
                  required
                  value={accountNo}
                  className="mb-2 custom-input"
                />
                <Form.Select
                  value={selectedAccountType}
                  onChange={(e) => setSelectedAccountType(e.target.value)}
                  className="mb-2 custom-input"
                  style={{ maxWidth: '430px' }}
                >
                  <option disabled value="">
                    Select Account Type
                  </option>
                  {BANK_VERIFICATION_ACCOUNT_TYPE_OPTIONS.searchBy.map(
                    (branch) => (
                      <option key={branch.id} value={branch.id}>
                        {branch.name}
                      </option>
                    ),
                  )}
                </Form.Select>
                <Form.Select
                  value={selectedVerificationReason}
                  onChange={(e) =>
                    setSelectedVerificationReason(e.target.value)
                  }
                  className="mb-2 custom-input"
                  style={{ maxWidth: '430px' }}
                >
                  <option disabled value="">
                    Select Verification Reason
                  </option>
                  {BANK_VERIFICATION_REASON.searchBy.map((branch) => (
                    <option key={branch.id} value={branch.id}>
                      {branch.name}
                    </option>
                  ))}
                </Form.Select>
                <FormInput
                  onChangeHandler={setYourReference}
                  placeHolderText="Search reference"
                  value={yourReference}
                  className="mb-2 custom-input"
                />
              </>
            )}

            {searchBySelectedOption === 'TRUST' && (
              <>
                <FormInput
                  onChangeHandler={setiDorPassportNo}
                  placeHolderText="Trust Number"
                  value={iDorPassportNo}
                  className="mb-2 custom-input"
                />
                <FormInput
                  onChangeHandler={setCompanyorTrustName}
                  placeHolderText="Trust Name"
                  required
                  value={companyorTrustName}
                  className="mb-2 custom-input"
                />
                <Form.Select
                  value={selectedBranchCode}
                  onChange={(e) => setSelectedBranchCode(e.target.value)}
                  className="mb-2 custom-input"
                  style={{ maxWidth: '430px' }}
                >
                  <option disabled value="">
                    Select Branch Code
                  </option>
                  {BANK_VERIFICATION_BRANCH_CODE_OPTIONS.searchBy.map(
                    (branch) => (
                      <option key={branch.id} value={branch.id}>
                        {branch.name}
                      </option>
                    ),
                  )}
                </Form.Select>
                <FormInput
                  onChangeHandler={setAccountNo}
                  placeHolderText="Account number"
                  required
                  value={accountNo}
                  className="mb-2 custom-input"
                />
                <Form.Select
                  value={selectedAccountType}
                  onChange={(e) => setSelectedAccountType(e.target.value)}
                  className="mb-2 custom-input"
                  style={{ maxWidth: '430px' }}
                >
                  <option disabled value="">
                    Select Account Type
                  </option>
                  {BANK_VERIFICATION_ACCOUNT_TYPE_OPTIONS.searchBy.map(
                    (branch) => (
                      <option key={branch.id} value={branch.id}>
                        {branch.name}
                      </option>
                    ),
                  )}
                </Form.Select>
                <Form.Select
                  value={selectedVerificationReason}
                  onChange={(e) =>
                    setSelectedVerificationReason(e.target.value)
                  }
                  className="mb-2 custom-input"
                  style={{ maxWidth: '430px' }}
                >
                  <option disabled value="">
                    Select Verification Reason
                  </option>
                  {BANK_VERIFICATION_REASON.searchBy.map((branch) => (
                    <option key={branch.id} value={branch.id}>
                      {branch.name}
                    </option>
                  ))}
                </Form.Select>
                <FormInput
                  onChangeHandler={setYourReference}
                  placeHolderText="Search reference"
                  value={yourReference}
                  className="mb-2 custom-input"
                />
              </>
            )}

            <div className="footer-btns">
              {!showProgress && (
                <FooterButtons
                  setShow={setShow}
                  handleSearch={handleBankVerificationSearch}
                />
              )}
            </div>
          </>
        )}
      </>
    </ScreenLayout>
  )
}
